<template>
    <div
        class="checkbox"
        :style="colorStyle"
        :class="{ '-checked': value, '-semi': semi, '-read-only': readOnly }"
        @click="check"
    >
        <i v-if="value" class="material-icons">check</i>
    </div>
</template>
<script>
export default {
    name: 'Checkbox',
    props: {
        value: [Boolean, String],
        semi: Boolean,
        readOnly: Boolean,
        color: String
    },
    computed: {
        colorStyle() {
            let style = { borderColor: this.$Utils.colors[this.color] }
            if (this.value) {
                style.backgroundColor = this.$Utils.colors[this.color]
            }
            return style
        }
    },
    methods: {
        check() {
            this.$emit('input', !this.value)
            this.$forceUpdate()
        }
    }
}
</script>
<style lang="scss" scoped>
.checkbox {
    height: 1.5rem;
    width: 1.5rem !important;
    min-width: 1.5rem !important;
    min-height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: $action-accent solid 0.1rem;
    border-radius: 0.2rem;
    cursor: pointer;
    transition: $ease;
    user-select: none;

    &:hover {
        transform: $translateY;
    }

    &.-read-only {
        cursor: default;
        &:hover {
            transform: translateY(0px);
        }
    }
    &.-checked {
        background-color: $action-accent;
    }
    &.-semi {
        border-color: $action-accent !important;
        background-color: lighten($action-accent, 35%);
    }
}
.checkbox i {
    color: #fff;
}
</style>
